const searchInputsItems = document.querySelectorAll('.input--search')

searchInputsItems.forEach(item => {
  const input = item.querySelector('input')
  const clearBtn = item.querySelector('.clear-search-btn')

  if (!input || !clearBtn) return

  clearBtn.addEventListener('click', () => {
    input.value = ''

    input.focus()
    const event = new Event("input")
    input.dispatchEvent(event)
  })
})